var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('h1',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_c('p',[_vm._t("default",[(_vm.action)?_c('button',{staticClass:"btn btn-success btn-sm",class:_vm.buttonClasses,attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e()])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f53a4b02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sharedComponents/emptyState.vue
// module id = MwGA
// module chunks = 1